const exceptionalMarket = (marketName) => {
    switch (marketName) {
        case 'po-st':
            return {
                lang: 'en',
            };
        default:
            return false;
    }
};

const getLang = (marketName) => exceptionalMarket(marketName).lang || marketName.slice(3, 5);

const countryToUppercase = (marketName) => marketName.slice(0, 2).toUpperCase();

const getBuildPath = (marketName) => {
    return marketName.replace('-', '/');
};

module.exports = { getBuildPath, getLang, countryToUppercase };
